import styled, {css} from 'styled-components';

import {mq} from 'utils/responsive';

const GridField = styled.div`
  display: ${({columns}) => ((columns && columns !== '1fr') ? 'grid' : 'flex')};
  ${({columns, rows}) => ((columns && columns !== '1fr') ? css`
    grid-template-columns: ${columns};
    grid-template-rows: ${rows || '1fr'};
  ` : css`
    flex-direction: column;
  `)}
  gap: 12px;
  ${({area}) => area && css`grid-area: ${area};`}

  ${mq.ltsm`
    display: flex;
    flex-direction: column;
  `}
`;

export default GridField;
